import { Component, AfterViewInit, ViewChild, ElementRef} from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import ConfettiGenerator from "confetti-js";
import { CampaignsProvider }  from '@providers/campaigns/campaigns';
import { TabsPage } from '@pages';

@IonicPage()
@Component({
  selector: 'page-fin-campania',
  templateUrl: 'fin-campania.html',
})
export class FinCampaniaPage implements AfterViewInit {

  estadisticas: any;
  targetId: string;
  next: boolean = false;
  end: boolean = false;
  muestraTotales: boolean = false;
  muestraLista: boolean = false;
  showModal: boolean = false;
  @ViewChild('btnNext') btnNext: ElementRef;
  @ViewChild('btnEnd') btnEnd: ElementRef;
  @ViewChild('totales') totales: ElementRef;
  @ViewChild('lista') lista: ElementRef;
  readonly AUDIO_FIN = 'assets/audios/campania_fin.wav';
  readonly AUDIO_PUNTOS = 'assets/audios/suma_score_campania.wav';
  private  audio = new Audio();

  constructor(
    private campaignsProvider: CampaignsProvider,
    public navCtrl: NavController,
    public navParams: NavParams
  ) {
    this.estadisticas = navParams.get('estadisticas');
    this.targetId = `confetti-${Math.random().toString(36).substring(7)}`;
  }

  ionViewDidEnter() {
  }

  ngAfterViewInit() {
    let confettiSettings = { target: this.targetId, rotate: true };
    let confetti = new ConfettiGenerator(confettiSettings);
    confetti.render();

    this.audio.src = this.AUDIO_FIN;
    this.audio.load();
    this.audio.play();

    setTimeout( _ => {
      this.next = true;
      setTimeout( _ => {
        this.btnNext.nativeElement.classList.remove('hide')
        this.btnNext.nativeElement.classList.add('animated', 'zoomIn');
      })
    }, 2000);
  }

  modal() {
    this.showModal = true;
    this.audio.src = this.AUDIO_PUNTOS;
    this.audio.load();
    this.audio.play();

    setTimeout( _ => {
      this.muestraLista = true;
      setTimeout( _ => {
        this.lista.nativeElement.classList.remove('hide');
        this.lista.nativeElement.classList.add('animated', 'zoomIn');
      })
    });

    setTimeout( _ => {
      this.muestraTotales = true;
      setTimeout( _ => {
        this.totales.nativeElement.classList.remove('hide');
        this.totales.nativeElement.classList.add('animated', 'zoomIn');
      })
    }, 1000);

    setTimeout( _ => {
      this.end = true;
      setTimeout( _ => {
        this.btnEnd.nativeElement.classList.remove('hide');
        this.btnEnd.nativeElement.classList.add('animated', 'zoomIn');
      })
    }, 2000);
  }

  close() {
    this.campaignsProvider.hideModalFinCampania();
    this.navCtrl.setRoot(TabsPage);
  }

}



// WEBPACK FOOTER //
// ./src/pages/fin-campania/fin-campania.ts